import resolveDefaultProps from "utils/resolveDefaultProps";
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const IconText = (providedProps) => {
  const {className, asElement: Component,  icon, children} = resolveDefaultProps(providedProps, IconTextDefaults);

	return (
		<Component className={classNames('flex items-center gap-2', className)}>
			{icon}
			{children}
		</Component>
	)
}

const IconTextDefaults = {
	asElement: 'span'
}

IconText.propTypes = {
	asElement: PropTypes.string,
	icon: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.node
	]),
}

export default IconText
